import React, { FunctionComponent } from "react";
import { ChevronLeftIcon } from "./ChevronLeftIcon";
import { IconProps } from "./IconProps";

const ChevronRightIcon: FunctionComponent<IconProps> = (props) => {
  return <ChevronLeftIcon {...props} isChevronRight={true} />;
};

export { ChevronRightIcon };
